export enum ContentItemType {
  RichText = 'rich_text',
  SingleImage = 'single_image',
  MultipleImages = 'multiple_images',
  SubTitle = 'sub_title',
  RichTextTwoCols = 'rich_text_2_cols',
  RichTextThreeCols = 'rich_text_3_cols',
  ImagesLinks = 'images_links',
  Unknown = 'unknown',
  Error = 'error',
  Embed = 'embed',
  Space = 'space',
}



// WEBPACK FOOTER //
// ./src/module/Model/Content/item/ContentItemType.ts